import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/profile/company/_layout/')({
  component: undefined,
  beforeLoad: async () => {
    throw redirect({
      to: '/profile/company/cr-information',
      replace: true,
    });
  },
});
